import { createApi } from '@reduxjs/toolkit/query/react';

import type { AircraftStatus } from '#entities/types';

import {
  fetchWithAuthBaseQuery,
  validateAndTransformResponse,
} from '#shared/api';
import type { DataWithValidation } from '#shared/api';

import {
  aircraftStatusesResponseSchema,
  type AircraftStatusesResponse,
} from './schemas';

const paths = {
  aircraftStatuses: 'api/aircraftStatuses',
} as const;

export const aircraftStatusesApi = createApi({
  reducerPath: 'aircraftStatusesApi',

  baseQuery: fetchWithAuthBaseQuery,
  refetchOnReconnect: true,
  endpoints: build => ({
    getAircraftStatuses: build.query<
      DataWithValidation<AircraftStatus[]>,
      void
    >({
      query: () => paths.aircraftStatuses,
      transformResponse: (response: AircraftStatusesResponse) =>
        validateAndTransformResponse(
          aircraftStatusesResponseSchema,
          response,
          value => value?.Registration,
          'aircraftStatuses',
          true,
        ),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetAircraftStatusesQuery } = aircraftStatusesApi;
